import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2SitePrivacyQueryVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
}>;

export type WebsiteV2SitePrivacyQuery = {
  __typename?: 'Query';
  carbonWebsiteSiteById?: {
    __typename?: 'CarbonWebsiteSite';
    id: string;
    settings?: {
      __typename?: 'CarbonWebsiteSiteSettings';
      privacy?: {
        __typename?: 'CarbonWebsiteSitePrivacy';
        visibility: Types.CarbonWebsiteSiteVisibility;
        hasPassword?: boolean | null;
        validateGuestIdentity?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export const WebsiteV2SitePrivacyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2SitePrivacy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteSiteById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privacy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasPassword' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'validateGuestIdentity' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2SitePrivacyQuery__
 *
 * To run a query within a React component, call `useWebsiteV2SitePrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2SitePrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2SitePrivacyQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useWebsiteV2SitePrivacyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2SitePrivacyQuery, WebsiteV2SitePrivacyQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2SitePrivacyQuery, WebsiteV2SitePrivacyQueryVariables>(WebsiteV2SitePrivacyDocument, baseOptions);
}
export function useWebsiteV2SitePrivacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2SitePrivacyQuery, WebsiteV2SitePrivacyQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2SitePrivacyQuery, WebsiteV2SitePrivacyQueryVariables>(WebsiteV2SitePrivacyDocument, baseOptions);
}
export type WebsiteV2SitePrivacyQueryHookResult = ReturnType<typeof useWebsiteV2SitePrivacyQuery>;
export type WebsiteV2SitePrivacyLazyQueryHookResult = ReturnType<typeof useWebsiteV2SitePrivacyLazyQuery>;
export type WebsiteV2SitePrivacyQueryResult = Apollo.QueryResult<WebsiteV2SitePrivacyQuery, WebsiteV2SitePrivacyQueryVariables>;
